// extracted by mini-css-extract-plugin
module.exports = {"ibox":"ContainerBox_ibox__1XY_i","iboxTitle":"ContainerBox_iboxTitle__3B_Ha","iboxContent":"ContainerBox_iboxContent__HOZTW"};